<template>
  <div class="dynamic-table">
    <div v-if="!disabled" class="btn-group m-l-20 m-b-20">
      <div class="input-btn m-r-20">
        <el-button type="primary">导入Excel表格</el-button>
        <input ref="inputBtn" type="file" accept="" @change="getExcelFile" />
      </div>
      <el-button
        type="primary"
        @click="editTableHeadDialog = true"
      >添加表格项</el-button>
    </div>

    <!--表格展示-->
    <jczh-table-content
      :option="tableConfig"
      :data="tableList"
      max-height="460"
    >
      <!--自定义表头-->
      <template v-if="!disabled" slot="header" slot-scope="{ option }">
        <el-dropdown trigger="click" size="medium">
          <div class="dropdown-link">
            <div>{{ option.label || '' }}</div>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              @click.native="selectTableHead(option)"
            >编辑</el-dropdown-item>
            <el-dropdown-item
              @click.native="deleteTableHead(option)"
            >删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <!--表格操作-->
      <template slot="operate" slot-scope="{ row, rowIndex }">
        <template v-if="!disabled">
          <el-button
            type="text"
            @click="selectTableRow(row, rowIndex)"
          >编辑</el-button>
          <el-button
            type="text"
            class="danger-button"
            @click="deleteTableRow(row, rowIndex)"
          >删除</el-button>
        </template>
        <el-button type="text" @click="selectTableRow(row, rowIndex, true)">
          查看详情
        </el-button>
      </template>
    </jczh-table-content>
    <!--添加行的按钮-->
    <div
      v-if="!disabled"
      class="table-bottom-btn"
      @click="tableDataDialog = true"
    >
      <i class="el-icon-plus m-r-10"></i> 添加行
    </div>

    <!--添加表格数据弹窗-->
    <jczh-drawer
      :title="`${watchDetail ? '' : isEdit ? '编辑' : '添加'}标的信息`"
      :visible.sync="tableDataDialog"
      size="600px"
      @close="clearTableDataDialog"
      @confirm="() => (isEdit ? editTableRow() : addTableData())"
    >
      <el-form
        slot="content"
        :model="formData"
        size="small"
        label-suffix="："
        class="m-t-20"
      >
        <el-form-item
          v-for="item in tableHeaderConfig"
          :key="item.attrName"
          :label="item.attrName"
          :class="{ 'detail-item': watchDetail }"
        >
          <el-input
            v-if="!disabled"
            v-model="formData[item.attrName]"
            :placeholder="`请输入${item.attrName}`"
            maxlength="200"
            show-word-limit
          />
          <span v-else>{{ formData[item.attrName] || '-' }}</span>
        </el-form-item>
      </el-form>
    </jczh-drawer>

    <!--编辑表格项-->
    <el-dialog
      :title="`${isEdit ? '编辑' : '添加'}表格项`"
      :visible.sync="editTableHeadDialog"
      :close-on-click-modal="false"
      :before-close="clearTableHeadDialog"
      width="50rem"
      class="dialog"
    >
      <el-form
        :model="editTableHeadForm"
        :rules="editTableHeadRules"
        size="small"
        label-suffix="："
        label-width="120px"
      >
        <el-form-item label="表格项名称" prop="attrName">
          <el-input
            v-model="editTableHeadForm.attrName"
            :placeholder="`请输入表格项名称`"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="clearTableHeadDialog">取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="() => (isEdit ? editTableHead() : addTableHead())"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 工具函数
import { cloneDeep } from 'lodash'
// 引入api
import { importExcelDemandApi } from '@/api/procure/demand'

export default {
  name: 'DynamicTable',

  props: {
    tableData: {
      type: Array,
      default: () => []
    },

    tableHeaderConfig: {
      type: Array,
      default: () => []
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      isEdit: false,
      // 添加表格数据的表单变量
      formData: {},
      tableDataDialog: false,
      editTableRowIndex: '',
      watchDetail: false,

      // 编辑表格项
      editTableHeadIndex: '',
      tableHeadBefore: '', // 修改前的表格名称
      editTableHeadDialog: false,
      editTableHeadForm: {
        attrName: ''
      },
      editTableHeadRules: {
        attrName: {
          required: true,
          message: '请输入表格项名称',
          trigger: ['blur']
        }
      }
    }
  },

  computed: {
    // 表格配置
    tableConfig() {
      const temp = this.tableHeaderConfig.map(value => {
        return {
          label: value.attrName,
          prop: value.attrName,
          headerSlot: 'header'
        }
      })

      return [
        ...temp,
        {
          label: '操作',
          prop: '',
          slotName: 'operate',
          width: '160'
        }
      ]
    },

    // 表格表头字段
    tableHeaderConfigTemp: {
      get() {
        return this.tableHeaderConfig
      },
      set(val) {
        this.$emit('update:tableHeaderConfig', val)
      }
    },

    // 表格数据
    tableList: {
      get() {
        return this.tableData
      },
      set(val) {
        this.$emit('update:tableData', val)
      }
    }
  },

  watch: {
    tableHeaderConfig: {
      handler: function() {
        const temp = {}
        this.tableHeaderConfig.map(value => {
          temp[value.attrName] = ''
        })
        this.formData = temp
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    // 清空添加表格数据的表单数据
    clearTableDataDialog() {
      Object.keys(this.formData).forEach(key => {
        this.formData[key] = ''
      })
      this.editTableRowIndex = ''
      this.tableDataDialog = false
      this.isEdit = false
      this.watchDetail = false
    },

    // 清空编辑表格项的表单数据
    clearTableHeadDialog() {
      this.editTableHeadForm.attrName = ''
      this.editTableHeadIndex = ''
      this.tableHeadBefore = ''
      this.editTableHeadDialog = false
      this.isEdit = false
    },

    // 导入Excel表格
    async getExcelFile(e) {
      const files = Array.from(e.currentTarget.files)
      this.$refs.inputBtn.value = ''

      // 如果表格已经有数据，提示用户将会覆盖
      if (this.tableList.length) {
        const result = await this.$systemConfirm(
          '本次导入将覆盖当前表格数据，是否继续'
        )
        if (!result) return
      }

      if (!files.length) {
        this.$message.error('请选择上传的文件')
        return
      }

      importExcelDemandApi({ file: files[0] })
        .then(res => {
          const data = res?.data || {}
          const tableList = data.materielValueList || []
          if (tableList.length > 200) {
            this.$message.warning('标的条数上限为200条')
            return
          }
          this.tableHeaderConfigTemp = data.materielAttrList || []
          this.tableList = tableList
        })
        .catch(err => {
          this.$message.error(err?.message || '导入失败')
        })
    },

    // 确定添加表格数据
    addTableData() {
      const temp = cloneDeep(this.formData)
      this.tableList.push(temp)

      this.clearTableDataDialog()
    },

    // 选择编辑表格行数据
    selectTableRow(row, rowIndex, watchDetail = false) {
      this.isEdit = true
      this.editTableRowIndex = rowIndex
      this.watchDetail = watchDetail

      this.tableHeaderConfigTemp.forEach(value => {
        this.formData[value.attrName] = row[value.attrName]
      })

      this.tableDataDialog = true
    },

    // 编辑表格行数据
    editTableRow() {
      const temp = cloneDeep(this.formData)
      this.tableList.splice(this.editTableRowIndex, 1, temp)

      this.clearTableDataDialog()
    },

    // 删除表格行数据
    deleteTableRow(row, rowIndex) {
      this.$systemConfirm('确定删除该行数据？').then(result => {
        if (!result) return

        this.tableList.splice(rowIndex, 1)
      })
    },

    // 添加表格项
    addTableHead() {
      const temp = cloneDeep(this.editTableHeadForm)
      this.tableHeaderConfigTemp.push(temp)

      this.clearTableHeadDialog()
    },

    // 选择编辑的表格项
    selectTableHead(config) {
      this.isEdit = true
      this.editTableHeadForm.attrName = config.label
      this.tableHeadBefore = config.label
      this.editTableHeadIndex = this.tableHeaderConfigTemp.findIndex(
        value => value.attrName === config.label
      )
      this.editTableHeadDialog = true
    },

    // 完成表格项的编辑
    editTableHead() {
      this.tableHeaderConfigTemp[
        this.editTableHeadIndex
      ].attrName = this.editTableHeadForm.attrName

      this.tableList.forEach(value => {
        value[this.editTableHeadForm.attrName] = value[this.tableHeadBefore]
        delete value[this.tableHeadBefore]
      })

      this.clearTableHeadDialog()
    },

    // 删除表格项
    deleteTableHead(config) {
      this.$systemConfirm('确定删除该表格项及其数据？').then(result => {
        if (!result) return

        const tableHead = config.label

        const tableHeadIndex = this.tableHeaderConfigTemp.findIndex(
          value => value.attrName === config.label
        )
        this.tableHeaderConfigTemp.splice(tableHeadIndex, 1)

        this.tableList.forEach(value => {
          delete value[tableHead]
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.dynamic-table {
  // 文件上传按钮
  .input-btn {
    display: inline-block;
    position: relative;
    overflow: hidden;
    vertical-align: top;

    input {
      position: absolute;
      top: 0;
      left: -150px;
      width: calc(260% + 150px);
      height: 100%;
      z-index: 1;
      opacity: 0;
      cursor: pointer;
    }
  }

  .dropdown-link {
    display: flex;
    align-items: center;
    cursor: pointer;

    i {
      flex-shrink: 0;
    }

    &:hover {
      color: $primary-color;
    }
  }

  //表格底部的按钮
  .table-bottom-btn {
    background: $primary-background-color;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $primary-color;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
